<template>
  <div  >
    <div v-if="chartMainData" class="column-chart-template">
      <div class="column-chart-template__header">
        <div class="column-chart-template__header-title">{{ chartTitle }}</div>
        <div v-if="projectsByMonth"  class="column-chart-template__header-title-projects">
          <ModelAutoComplete
            v-loading.small="!getAllProjectsList"
            label="Выберите проект"
            :items="allProjectsList"
            :vizKeyPath="[
              ['name'],
            ]"
            @debounce-end="getAutocompletedProjects"
            @selected="selectProject"
            
          />
        </div>
        <div  class="column-chart-template__year-selector">
          <ModelSelect
            label="Год"
            item-text="value"
            :items="getYearsRange"
            v-model="year"
          />
        </div>
      </div>
      <div class="column-chart-template__chart-wrapper">
        <div v-if="selectedProjectName && projectsByMonth" class="column-chart-template__hint">Отображена статистика по проекту «{{ selectedProjectName }}»</div>
        <VueApexCharts :height="chartHeight" :series="getSeries" :options="getOptions"  type="bar"/>
      </div> 
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import ModelAutoComplete from '@/components/UI/models/ModelAutoComplete';
import ModelSelect from '@/components/UI/models/ModelSelect';
import {CHART_MONTHS, CHART_DEFAULT_COLORS, getDefaultColumnBarOptions } from '../chartHelper';
import { mapGetters } from 'vuex';

export default {
  name: "ColumnBarChartTemplate",
  components: {
    VueApexCharts,
    ModelSelect,
    ModelAutoComplete,
    
  },
  props: {
    chartTitle: {
      type: String,
    },
    projectsByMonth: {
      type: Boolean,
    },
    yearStart: {
      type: Number,
    },
    chartMainData: {
      type: Object,
    },
    chartSeriesYKey: {
      type: String,
    },
    chartHeight: {
      type: Number,
    },
    chartOptionsFuncParams: {
      type: Object,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      allProjectsList: this.getAllProjectsList,
      selectedProjectName: "",
    };
  },
  watch: {
    year(value) {
      this.$emit('year-update', value);
    },
  },
  methods: {
    getAutocompletedProjects(data) {
      this.allProjectsList = this.getAllProjectsList.filter((item) => {
        return item.name.toLowerCase().includes(data.value.toLowerCase().trim());
      });
    },
    selectProject(data) {
      this.selectedProjectName = data.name;
      this.$emit('project-update', data.id);
    },
  },
  computed: {
    ...mapGetters(['getAllProjectsList']),
    getOptions() {
      return getDefaultColumnBarOptions(this.chartOptionsFuncParams.title);
    },
    getSeries() {
      const currentKey = Object.keys(this.chartMainData)[0];
        return [{
        data: CHART_MONTHS.map((month, index) => {
          const resultData = this.chartMainData[currentKey].find((item) => {
            if((item.month - 1) === index) {
              return item;
            }
          });
          return {y: resultData && resultData[this.chartSeriesYKey] || 0, x: month, fillColor: CHART_DEFAULT_COLORS[index]};
        }),
      }];
    },
    getYearsRange() {
      const yearsRange = [];
      for (let year = this.yearStart; year <= new Date().getFullYear(); year++ ) {
        yearsRange.unshift({value: year});
      }
      return yearsRange;
    },
  },
}; 
</script>
<style lang="scss">
@import '~@/styles/rem';
@import '~@/styles/chart_styles';
@import '~@/styles/variables';

.column-chart-template {
  display: flex;
  flex-direction: column;
  border-radius: rem(16);
  padding: rem(20);
  box-shadow: 0 0 50px rgba(70, 99, 171, 0.16);
  

  &__hint {
    color: #4663AB;
    font-size: rem(16);
    line-height: rem(24);
    font-weight: 500;
    margin-top: rem(20);

  }
  &__header {
    display: flex;
    justify-content: space-between;
    gap: rem(22);

    &-title {
      font-family: 'Montserrat';
      font-size: rem(20);
      font-weight: 600;
      line-height: rem(30);
      min-width: rem(635);
      margin: 0;
      align-self: center;
      text-transform: uppercase;

      &-projects {
        width: rem(356);
      }
    }
  }
  &__year-selector {
    width: rem(120);
  }

  &__chart-wrapper {
    width: 100%;
  }
}

.arrow-box {
  background: rgba(255, 255, 255, 1);
  font-size: rem(14);
  line-height: rem(20);
  display: flex;
  flex-direction: column;
  padding: rem(16);
  border-radius: rem(10);

  span:first-child {
    font-weight: 600;
  }
}

.apexcharts-tooltip {
  border: none !important;
  border-radius: rem(10);
}
</style>